module.exports = __webpack_public_path__ + "static/media/CD__0005_0001.12f7727d.png";